module.exports = __webpack_public_path__ + "static/media/bg-about-us-3.7c0c73bc.jpg";